<template>
  <AuthFormWrapper title="Allgemeine Geschäftsbedingungen">
    <div class="flex flex-col gap-4">
      <TosCheckbox v-model="tosAccepted" />

      <p class="text-xs text-neutral">
        Die Zustimmung ist erforderlich, um INFRA|Wärme nutzen zu können. Wenn
        Sie nicht zustimmen möchten, können Sie den Vorgang abbrechen.
      </p>

      <div
        v-if="errorMessage"
        class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-red-700"
      >
        <span class="text-sm">{{ errorMessage }}</span>
      </div>

      <div class="flex gap-3">
        <ButtonEl
          text="Abbrechen"
          :full-width="true"
          variant="secondary"
          :disabled="isSubmitting"
          @click="onCancel"
        />
        <ButtonEl
          text="Bestätigen"
          :full-width="true"
          :disabled="!tosAccepted || isSubmitting"
          @click="onConfirm"
        />
      </div>
    </div>
  </AuthFormWrapper>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import cookie from 'vue-cookies';
import { axios } from '@/utils/axiosHelper';
import AuthFormWrapper from '@/apps/auth/AuthFormWrapper.vue';
import ButtonEl from '@/components/storybook/src/stories/button/ButtonEl.vue';
import TosCheckbox from './TosCheckbox.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();

const tosAccepted = ref(false);
const isSubmitting = ref(false);
const errorMessage = ref('');

async function onCancel() {
  await store.dispatch('auth/LOGOUT');
  await router.push({ name: 'Login' });
}

async function onConfirm() {
  if (!tosAccepted.value || isSubmitting.value) return;

  isSubmitting.value = true;
  errorMessage.value = '';

  try {
    await axios({
      method: 'POST',
      url: '/api/accept-tos/',
      headers: { 'X-CSRFToken': cookie.get('csrftoken') },
    });

    const redirectUrl = route.query.from || '/';
    await router.push(redirectUrl);
  } catch {
    errorMessage.value =
      'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.';
  } finally {
    isSubmitting.value = false;
  }
}
</script>
